// Module
var code = "<template surface=\"card\"> <require from=\"./card-skeleton.scss\"></require> </template> ";
// Exports
module.exports = code;